export const TITLE = 'Drag & Drop your file here or click to select a file';
export const TITLE_ARRAY = [
  ['Drag & Drop Supporting Documents', null],
  ['or', null],
  ['Select a file', { textDecoration: 'underline' }],
];
export const SUBTITLE = '(15 MB max file size. CSV, DOCX, JPG, PDF, XLSX, ZIP format file.)';
export const SUBTITLE_FOR_DROPPED_FILES = 'The uploaded document will be saved in the documents section.';
